import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { HttpUtilService } from "../http-util.service";

@Injectable({
  providedIn: "root",
})
export class AccountCodeCreationService {
  constructor(private http: HttpUtilService) {}

  getAccountCode(purpose: string): Observable<any> {
    const encodedPurpose = encodeURIComponent(`"${purpose}"`);
    const url = `AccountCodeCreationService.asmx/GetAccountCode?purpose=${encodedPurpose}`;
    return this.http.get(url);
  }

  getAccountPurpose(accountCode: string): Observable<any> {
    const encodedCode = encodeURIComponent(`"${accountCode}"`);
    const url = `AccountCodeCreationService.asmx/GetPurpose?accountCode=${encodedCode}`;
    return this.http.get(url);
  }

  add(accountCode: string, purpose: string): Observable<any> {
    return this.http.post("AccountCodeCreationService.asmx/Add", {
      accountCode,
      purpose,
    });
  }

  delete(porpose: string): Observable<any> {
    return this.http.post("AccountCodeCreationService.asmx/Delete", {
      porpose,
    });
  }
}
